export default {
	// common locales
	"MallUpload.upload-scope": "Scope",
	"MallUpload.upload-interval": "Upload Frequency",
	"MallUpload.include-tax": "Include Tax",
	"MallUpload.include-service-charge": "Include Svc Charge",
	"MallUpload.include-void": "Include Void Txns",
	"MallUpload.client-id": "Client ID",
	"MallUpload.upload-format": "Format",
	"MallUpload.upload-protocol": "Upload Protocol",
	"MallUpload.status": "Status",
	"MallUpload.enabled-from": "Active From",
	"MallUpload.enabled-from-date": "Active from {date}",
	"MallUpload.brand-name": "Brand",
	"MallUpload.outlet-name": "Outlet",
	"MallUpload.terminal-name": "Terminal",
	"MallUpload.payment-type": "Payment Type",
	"MallUpload.mall-name": "Mall",
	"MallUpload.include": "Amounts Include",
	"MallUpload.tax": "Tax",
	"MallUpload.service-charge": "Service Charge",
	"MallUpload.void-transactions": "Voided Transactions",
	"MallUpload.add-new-config": "New Data Upload Config",
	"MallUpload.edit-config": "Edit Data Upload Config",
	"MallUpload.view-config": "View Data Upload Config",
	"MallUpload.credentials": "Credentials",
	"MallUpload.client-id": "Client ID",
	"MallUpload.host": "Host",
	"MallUpload.port": "Port Number",
	"MallUpload.path": "Path",
	"MallUpload.username": "Username",
	"MallUpload.password": "Password",
	"MallUpload.filename": "Filename",
	"MallUpload.data": "Data",
	"MallUpload.upload-date": "Upload Date",
	"MallUpload.cancel-upload": "Cancel Upload",
	"MallUpload.config-id": "Config ID",
	"MallUpload.created-at": "CreatedAt",
	"MallUpload.re-upload": "Re-Upload",
	"MallUpload.re-upload.title": "Confirm Re-upload ",
	"MallUpload.re-upload.title2": " Files",
	"MallUpload.re-upload.subtitle": "Are you sure you want to re-upload the following Files",
	"MallUpload.view-only": "View Config",
	"MallUpload.main-config": "Main Config",

	// mall upload file
	"MallUpload.file.title": "Data Upload File",
	"MallUpload.file.cancel-title": "Cancel Data Upload File",
	"MallUpload.file.cancel-description": "This is an irreversible action. Are you sure you want to cancel uploading of this file?",
	"MallUpload.regenerate": "Regenerate",
	"MallUpload.file.regenerate-title": "Regenerate Data Upload File",
	"MallUpload.file.regenerate-description": "Are you sure you want to regenerate the data for this file based on the latest transaction data? After regeneration, it will be flagged for upload.",

	// page titles
	"MallUpload.config.page-description": "Configure Data Upload generation templates.",
	"MallUpload.files.page-description": "Files that have been created for data uploading.",
	"MallUpload.unposted-files.page-description": "Files that failed to upload to a destination and require your attention.",

	// placeholders / tooltips
	"MallUpload.upload-scope.placeholder": "Each file is one...",
	"MallUpload.upload-interval.placeholder": "Select upload frequency",
	"MallUpload.include.placeholder": "Select values to include",
	"MallUpload.upload-format.placeholder": "Select upload format",
	"MallUpload.upload-protocol.placeholder": "Select upload protocol",
	"MallUpload.mall-name.placeholder": "Select a mall",
	"MallUpload.client-id.placeholder": "Client ID for this specific upload",
	"MallUpload.host.placeholder": "FQDN or IP Address of the host server",
	"MallUpload.port.placeholder": "22",
	"MallUpload.path.placeholder": "File or folder path to upload to",
	"MallUpload.username.placeholder": "Enter username",
	"MallUpload.password.placeholder": "Enter password",
	"MallUpload.search.placeholder": "Search Reference No.",
	"MallUpload.config-id.placeholder": "Select a Config ID",
	"MallUpload.upload-interval.tooltip": "DAILY - Upload will only happen when all the terminals within the outlet have completed daily closing.",
	"MallUpload.upload-format.tooltip": "Refer to upos-data-upload-formats.zip for the Specifications Documents for each format.",

	// validation messages
	"MallUpload.upload-scope.required": "Each file is one...?",
	"MallUpload.upload-interval.required": "When to upload?",
	"MallUpload.upload-format.required": "What is the data upload format?",
	"MallUpload.upload-protocol.required": "What is the uploading protocol?",
	
	// enabling / disabling locales
	"MallUpload.uneditable.title": "This configuration cannot be edited",
	"MallUpload.uneditable.subtitle": "There are existing data upload files associated with this configuration. Please disable and create a new configuration if required.",
	"MallUpload.disable.prompt": "Are you sure you want to disable Data Upload Configuration for Config #{configId}?",
	"MallUpload.enable.prompt": "Are you sure you want to enable Data Upload Configuration for Config #{configId}?",
	"MallUpload.re-enable.prompt": "Last known data upload for Config #{configId} was created on {date}. When do you want to start uploading from?",
	"MallUpload.delete.prompt": "Are you sure you want to delete Data Upload Configuration ID #{configId}?",
};